module.exports = __webpack_public_path__ + "img/plh1.7128a5d2.png";